import { FC } from 'react';
import { parseISO, format } from 'date-fns';
import styles from './ReviewCard.module.scss';

interface IReviewCard {
  name: string;
  message: string;
  date: string;
  isBlogPage?: boolean;
}

const ReviewCard: FC<IReviewCard> = ({ name, message, date, isBlogPage }) => {
  const getUserName = (name: string) => {
    const USER_NAMES = [
      'Джеки',
      'Владимир',
      'Александр',
      'Beast',
      'Flowers Lover',
      'Борис',
      'Hawk',
      'Вика',
      'Горец',
      'Deep Stroke',
      'Alex',
      'Maria',
      'Anna',
      'Сool Fire',
      'Crystal',
      'Виктор',
      'Данила',
      'Макс',
      'Тим',
      'Spell Czech',
      'Funny Bunny',
      'Полина',
      'Lubov',
    ];

    const getRandomFloat = (min: number, max: number) => {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    const checkNoName = (name: string) => (name === 'аноним' ? USER_NAMES[getRandomFloat(0, USER_NAMES.length - 1)] : name);

    return isBlogPage ? checkNoName(name) : name;
  };

  return (
    <div className={styles.reviewsBlock__item}>
      <div className={styles.reviewsBlock__author}>
        <div className={styles.reviewsBlock__userName}>{getUserName(name)}</div>
        <div className={styles.reviewsBlock__date}>
          <time dateTime={date}>{format(parseISO(date), 'dd.MM.yy')}</time>
        </div>
      </div>
      <div className={styles.reviewsBlock__desk}>{message}</div>
    </div>
  );
};

export default ReviewCard;
